import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { STADIUM_CLUSTERS, STANDALONE_STADIUMS, StadiumCluster } from '../../constants/stadiumClusters';
import styles from './StadiumClusters.module.css';

const ClusterCard: FC<{ cluster: StadiumCluster }> = ({ cluster }) => {
  const navigate = useNavigate();
  const teamIds = cluster.stadiums.map(s => s.teamId).join(',');
  const handleClick = () => {
    navigate(`/?teams=${teamIds}`);
    const stops = cluster.stadiums.map(s => encodeURIComponent(s.name)).join('/');
    window.open(`https://www.google.com/maps/dir/${stops}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <span className={styles.emoji}>{cluster.emoji}</span>
        <div className={styles.cardHeaderText}>
          <h2 className={styles.clusterName}>{cluster.name}</h2>
          <p className={styles.tagline}>{cluster.tagline}</p>
        </div>
        <button className={styles.roadtripButton} onClick={handleClick}>
          Plan Roadtrip
        </button>
      </div>

      <ul className={styles.stadiumList}>
        {cluster.stadiums.map(stadium => (
          <li key={stadium.name} className={styles.stadiumItem}>
            <span className={styles.stadiumName}>{stadium.name}</span>
            <span className={styles.teamName}>{stadium.team}</span>
            {stadium.note && <span className={styles.note}>{stadium.note}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
};

export const StadiumClusters: FC = () => (
  <div className={styles.page}>
    <div className={styles.intro}>
      <h1 className={styles.pageTitle}>Nearby Stadiums</h1>
      <p className={styles.pageSubtitle}>
        MLB stadium clusters within ~4 hours of each other — perfect for a multi-game road trip.
      </p>
    </div>

    <div className={styles.grid}>
      {STADIUM_CLUSTERS.map(cluster => (
        <ClusterCard key={cluster.id} cluster={cluster} />
      ))}
    </div>

    <div className={styles.standaloneSection}>
      <div className={styles.standaloneHeader}>
        <span className={styles.emoji}>🧭</span>
        <div>
          <h2 className={styles.clusterName}>Standing Alone</h2>
          <p className={styles.tagline}>Not within 4 hours of any other MLB stadium</p>
        </div>
      </div>
      <div className={styles.standalonePills}>
        {STANDALONE_STADIUMS.map(stadium => (
          <div key={stadium.name} className={styles.pill}>
            <span className={styles.pillName}>{stadium.name}</span>
            <span className={styles.pillTeam}>{stadium.team}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);
